// CheckEmail.jsx
import React from "react";
import "../styles/auth.css";

const CheckEmail = () => {
  return (
    <div className="auth-container">
      <h2>Almost There!</h2>
      <p>
        We've sent a verification link to your email. Please check your inbox
        and click the link to verify your account.
      </p>
    </div>
  );
};

export default CheckEmail;
